module.exports = __webpack_public_path__ + "static/img/mobile_home_tzjsmfw_zydj.af44dca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_home_tzjsmfw_zydj.png
// module id = eeB1
// module chunks = 21